import { useTranslation } from 'react-i18next';
import en from '../en.json';
import ru from '../ru.json';

export const useTranslatedData = () => {
    const { i18n } = useTranslation();
    return i18n.language === 'ru' ? ru : en;
};
